import { RANKING_TIME, REQUEST_STALE_TIME_IN_MS } from '@/constants';
import {
  hackathonsQueryKeys,
  hackathonsStagesQueryKeys,
} from '@/data/services/querykeys';
import {
  addLiveStreamUrl,
  getCurrentStage,
  getLastStage,
} from '@/utils/hackathon';
import moment from 'moment';
import useInfiniteService from '../useInfiniteService';
import useListService from '../useListService';
import { useMemo } from 'react';

const currentDate = moment().toISOString();
const useHackathon = () => {
  const { results: hackathons, isInitialLoading } = useListService({
    ...hackathonsQueryKeys.list({ date: currentDate }),
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const currentHackathon = hackathons.at(0);

  const { results: lastHackathon } = useListService({
    ...hackathonsQueryKeys.list({ lastHackathon: true }),
    staleTime: REQUEST_STALE_TIME_IN_MS,
    enabled: !currentHackathon && !isInitialLoading,
  });

  const hackathon = currentHackathon || lastHackathon.at(0);

  const {
    results: hackathonsStages,
    isInitialLoading: isLoadingStages,
    refetch: refetchStages,
  } = useInfiniteService({
    ...hackathonsStagesQueryKeys.list({ hackathon: hackathon?.id }),
    staleTime: REQUEST_STALE_TIME_IN_MS,
    enabled: !!hackathon,
  });

  const isFinish = hackathonsStages.every(stage =>
    moment().isAfter(stage.endDate),
  );

  const lastStage = getLastStage(hackathonsStages);

  const isFinishRanking =
    lastStage &&
    moment().isAfter(moment(lastStage.endDate).add(...RANKING_TIME));

  const hackathonMemo = useMemo(() => {
    return addLiveStreamUrl(hackathon);
  }, [hackathon]);

  return {
    hackathon: hackathonMemo,
    hackathonsStages,
    currentStage: getCurrentStage(hackathonsStages),
    isFinish,
    isFinishRanking,
    isLoading: isInitialLoading || isLoadingStages,
    refetchStages,
  };
};

export default useHackathon;
